import axios from 'axios';

import {
    SMTP_CONFIG_LIST_REQUEST,
    SMTP_CONFIG_LIST_SUCCESS,
    SMTP_CONFIG_LIST_FAIL,

    SMTP_CONFIG_DETAILS_REQUEST,
    SMTP_CONFIG_DETAILS_SUCCESS,
    SMTP_CONFIG_DETAILS_FAIL,

    SMTP_CONFIG_DELETE_REQUEST,
    SMTP_CONFIG_DELETE_SUCCESS,
    SMTP_CONFIG_DELETE_FAIL,

    SMTP_CONFIG_CREATE_REQUEST,
    SMTP_CONFIG_CREATE_SUCCESS,
    SMTP_CONFIG_CREATE_FAIL,

    SMTP_CONFIG_UPDATE_REQUEST,
    SMTP_CONFIG_UPDATE_SUCCESS,
    SMTP_CONFIG_UPDATE_FAIL,

    SMTP_CONFIG_REQUEST,
    SMTP_CONFIG_FAIL,
    SMTP_CONFIG_RESET,
    SMTP_CONFIG_SUCCESS,

    SMTP_CONFIG_COUNT_SUCCESS,
    SMTP_CONFIG_COUNT_REQUEST,
    SMTP_CONFIG_COUNT_FAIL,

    SET_CURRENT_PAGE,
    

} from "../constants/smtpConfigConstants";

// use dispatch to dispatch the request and throw it into the reducer
export const listSmtpConfigs = (filter) => async (dispatch, getState) => {
    try {
        dispatch({ type: SMTP_CONFIG_LIST_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};
        // get the filter
        if (filter) {
            params = filter;
        }

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`  
            },
            params
        }
        const { data } = await axios.get('/api/v1/smtpConfig/all', config);

        dispatch({
            type: SMTP_CONFIG_LIST_SUCCESS,
            payload: data
        });


    } catch (error) {

        dispatch({
            type: SMTP_CONFIG_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : "An error occured, please try again later smtpConfigs",
        });
    }
}

// count smtpConfigs
export const countSmtpConfigs = () => async (dispatch, getState) => {
    try {
      dispatch({ type: SMTP_CONFIG_COUNT_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
  
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`
        },
      }
      const { data } = await axios.get('/api/v1/smtpConfig/count', config);

  
      dispatch({
        type: SMTP_CONFIG_COUNT_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch({
        type: SMTP_CONFIG_COUNT_FAIL,
        payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : "Failed to fetch smtpConfig counts",
      });
    }
  }
  


export const getSmtpConfigDetails = (_id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SMTP_CONFIG_DETAILS_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`/api/v1/smtpConfig/${_id}`, config);

        dispatch({
            type: SMTP_CONFIG_DETAILS_SUCCESS,
            payload: data
        });

    } catch (error) {
        dispatch({
            type: SMTP_CONFIG_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
}

export const deleteSmtpConfig = (_id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: SMTP_CONFIG_DELETE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.delete(
            `/api/v1/smtpConfig/${_id}/`,
            config
        )

        dispatch({
            type: SMTP_CONFIG_DELETE_SUCCESS,
        })


    } catch (error) {
        dispatch({
            type: SMTP_CONFIG_DELETE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const createSmtpConfig = (changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: SMTP_CONFIG_CREATE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const data = await axios.post(
            `/api/v1/smtpConfig/`,
            changes,
            config
        )

        dispatch({
            type: SMTP_CONFIG_CREATE_SUCCESS,
            payload: data,
        })


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }        dispatch({
            type: SMTP_CONFIG_CREATE_FAIL,
            payload: errorMessages,
        })
    }
}

const loadSmtpConfigBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
    });
};

// make smtpConfig using a local smtpConfig
export const makeSmtpConfig = (file, smtpConfigId, apiEndPoint, apiKey) => async (dispatch, getState) => {

    const smtpConfig = await loadSmtpConfigBase64(file);
    const smtpConfig_input = JSON.stringify({ "smtpConfig": smtpConfig });
    const {
        userLogin: { userInfo },
    } = getState()

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`
        }
    }

    const data = await axios.post(
        apiEndPoint,
        smtpConfig_input,
        config
    )
    try {
        dispatch({
            type: SMTP_CONFIG_RESET
        })
        await axios({
            method: "POST",
            url: apiEndPoint,

            data: JSON.stringify({ "data": smtpConfig }),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        }).then((response) => {
                dispatch({
                    type: SMTP_CONFIG_SUCCESS
                });
                if (smtpConfigId && response.data) {
                    dispatch(updateSmtpConfig(smtpConfigId, { smtpConfig: response.data }));
                }
            })
            .catch(function (error) {
                dispatch({
                    type: SMTP_CONFIG_FAIL
                });
                console.log(error.message);
            });
    }

    catch (error) {
        dispatch({
            type: SMTP_CONFIG_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }

}


export const updateSmtpConfig = (_id, changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: SMTP_CONFIG_UPDATE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const {data} = await axios.patch(
            `/api/v1/smtpConfig/${_id}/`,
            changes,
            config
        )

        dispatch({
            type: SMTP_CONFIG_UPDATE_SUCCESS,
            payload: data,
        })


        dispatch({
            type: SMTP_CONFIG_DETAILS_SUCCESS,
            payload: data
        })


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: SMTP_CONFIG_UPDATE_FAIL,
            // return a list of errors
            payload: errorMessages,
        })
    }
}